import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AreaConfigurationDTO } from "../models/configuration/AreaConfigurationDTO";
import { environment } from "../../../core/config/environment";

@Injectable({
  providedIn: "root"
})
export class AreaConfigurationService {

  private readonly url = `${environment.backend.apiBaseURL}/api/Job/AreasConfiguration`;

  constructor(private http: HttpClient) { }

  /** Used by CCM persona — returns non-disabled areas, supports buildQualityStepScope filter */
  getConfiguration(divisionId?: number, buildQualityStepScope?: number): Observable<AreaConfigurationDTO[]> {
    let url = this.url;
    if (divisionId) {
      url += `?divisionId=${divisionId}&includeDisabled=false`;
    }
    if (buildQualityStepScope) {
      url += `&buildQualityStepScope=${buildQualityStepScope}`;
    }
    return this.http.get<AreaConfigurationDTO[]>(url);
  }

  /** Used by Admin persona — returns all areas including disabled */
  getAreaConfiguration(divisionId?: number): Observable<AreaConfigurationDTO[]> {
    let url = this.url;
    if (divisionId) {
      url += `?divisionId=${divisionId}&includeDisabled=true`;
    }
    return this.http.get<AreaConfigurationDTO[]>(url);
  }

}
